// Port of src/app/components/nav-bar/home/subtitle/subtitle.component.{ts,html,scss}
// (mypart-subtitle). interval(5000) → setInterval; signals → useState.

import { useEffect, useRef, useState } from 'react';
import './Subtitle.scss';

const SUBTITLES: string[] = [
  'Upload an image or video to discover songs that match your visual.',
  'Type a text prompt to describe what music you\'re looking for.',
  'Add a song or artist to discover similar songs.',
  'Filter by mood, theme, genre, and more.'
];

export default function Subtitle() {
  // A flag to control the CSS class for fading.
  const [fade, setFade] = useState(false);
  const [mainSubtitle, setMainSubtitle] = useState(SUBTITLES[0]);
  // Keep track of the current subtitle index.
  const currentIndexRef = useRef(0);
  const fadeRef = useRef(false);

  useEffect(() => {
    const interval = setInterval(() => {
      // Begin by starting the fade-out animation.
      fadeRef.current = true;
      setFade(true);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const onTransitionEnd = () => {
    if (fadeRef.current) {
      // Update the index to the next subtitle.
      currentIndexRef.current = (currentIndexRef.current + 1) % SUBTITLES.length;
      setMainSubtitle(SUBTITLES[currentIndexRef.current]);
      // Remove the fade class so the element fades back in.
      fadeRef.current = false;
      setFade(false);
    }
  };

  return (
    <div className="big-search-title">
      <p className="search-title">AI Song Search</p>
      <p onTransitionEnd={onTransitionEnd}
         className={`search-subtitle transition-opacity duration-300${fade ? ' fade' : ''}`}>
        {mainSubtitle}
      </p>
    </div>
  );
}
